import React, { useState } from "react";
import Slider from "@mui/material/Slider";

interface Mark {
  value: number;
  label?: string;
}

interface ChaletSearchResultSliderProps {
  title: string;
  min: number;
  max: number;
  step: number;
  defaultValue: [number, number];
  onChange: (value: [number, number]) => void;
  marks: Mark[];
  numberType?: "money" | "distance" | string;
}

const ChaletSearchResultSlider: React.FC<ChaletSearchResultSliderProps> = ({
  title,
  min,
  max,
  step,
  defaultValue,
  onChange,
  marks,
  numberType,
}) => {
  const [value, setValue] = useState<[number, number]>(defaultValue);

  const handleChange = (_event: Event, newValue: number | number[]) => {
    const safeValue = newValue as [number, number];
    setValue(safeValue);
    onChange(safeValue);
  };

  // useEffect(() => {
  //   console.log("being set");
  //   setValue(defaultValue);
  // }, [defaultValue]);

  const formatNumberWithCommas = (number: number): string =>
    number.toLocaleString();

  const formatLabel = (markValue: number): string => {
    const formattedValue = formatNumberWithCommas(markValue);
    switch (numberType) {
      case "distance":
        return `${formattedValue}m`;
      case "money":
        return `£${formattedValue}`;
      default:
        return formattedValue;
    }
  };

  const formattedMarks: Mark[] = marks.map((mark) => ({
    ...mark,
    label: formatLabel(mark.value),
  }));

  return (
    <div style={{ margin: "20px 0" }}>
      <div className="refiner-heading">{title}</div>
      <Slider
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
        step={step}
        min={min}
        max={max}
        marks={formattedMarks}
      />
    </div>
  );
};

export default ChaletSearchResultSlider;
